import React, { useState, useMemo, useEffect } from "react";
import "../paymentTerms/PaymentTerms.scss";
import { useNavigate } from "react-router-dom";
import FetchData, { DeleteEntry, GetList } from "../../providers/dataProvider";
import useForm from "./useForm";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DataSearch from "../../utils/DataSearch";
import { useRolePermission } from "../../hooks/useRolePermission";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DeleteModal from "../../components/common/DeleteModal";
import DataTable from '../../components/common/DataTable';
import { CheckNull } from '../../utils/Validate';
import ErrorMessage from '../../components/common/ErrorMessage';
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import Avatar from "../../components/common/Avatar";
import Chip from "../../components/common/Chip";
import PaymentTermsGrid from "../../components/paymentTerms/PaymentTermsGrid";
import { SearchComponent } from "../../components/common/SearchComponent";

const PaymentTermsList = () => {
  const [paymentTermsData, setPaymentTermsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [deleteShow, setDeleteShow] = useState({ show: false, item: "", title: '', textCode: '', text: '', loading: false });
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState([]);
  const [filterColumn, setFilterColumn] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: ""
  });

  const { menuRights } = useRolePermission("Payment Terms")

  const { show, setShow, createMsg, setCreateMsg, setValues, SuccessDoneClick, listData, setListData } = useForm("redirect");

  const { data: paymentTermsList, loading: loadingList } = FetchData("paymentterms");

  const [refreshSearch, setRefreshSearch] = useState(false);

  const baseColumns = [
    {
      heading: "Payment Terms",
      value: "paymentDescription",
      sortable: true,
    },
    {
      heading: "Credit Days",
      value: "creditDays",
      sortable: true,
    },
    {
      heading: "Description",
      value: "paymentTooltip",
      sortable: true,
    },
    {
      heading: "Status",
      value: "status",
      sortable: true,
    },
  ];



  useEffect(() => {
    if (paymentTermsList) setPaymentTermsData(paymentTermsList);
  }, [paymentTermsList])


  useEffect(() => {
    let filterdata = paymentTermsData.map((filterItem, index) => {
      filterItem.status = filterItem.isActive === true ? "Active" : "Inactive";
      filterItem['view'] = menuRights?.canView === true ? 'VIEW' : 'NOT-VIEW'
      return filterItem;
    });
    filterdata = [...filterdata]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (search != '') ApplySearch()
    else setTableData(filterdata)
  }, [paymentTermsData, menuRights]);



  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);


  const handleEdit = (item) => {
    if (item)
      navigate("/add-payment-terms", {
        state: {
          row: item,
          id: item?.id,
          canAdd: menuRights?.canAdd,
          canEdit: menuRights?.canEdit
        },
      });
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: 'You want delete this Payment Terms?',
      textCode: 'Payment Terms',
      text: item?.paymentDescription,
      loading: false
    })
  };

  const handleCancelDelete = () => {
    setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
  };


  const ErrorDoneClick = () => {
    setErrorShow(
      {
        show: false,
        errorMessage: ""
      })
    setCreateMsg(null);
  }

  const handleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true
    })
    DeleteEntry(
      "paymentterms",
      item,
      setCreateMsg,
      SuccessMessages?.DELETED("Payment terms"),
      ErrorMessages?.DELETED_ERROR("Payment terms")
    );
  };

  useEffect(() => {
    if (createMsg?.status === 200) {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
        setShow(true);
        GetList("paymentterms", "", setListData);
      }
    } else {

      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
        setErrorShow({ show: true, errorMessage: createMsg.message })
        setShow(false);
      }
    }
  }, [createMsg]);

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(paymentTermsData, search, baseColumns);
    SearchResult = [...SearchResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt)
    });
    setTableData(SearchResult);
    setRefreshSearch(false);
  };

  const removeSearch = () => { setSearch(""); setRefreshSearch(true) };

  useEffect(() => {
    if (refreshSearch === true || search == '') ApplySearch();
  }, [search])


  const RefreshList = () => { window.location.reload() }

  useEffect(() => {
    if (listData?.message == "success") {
      setPaymentTermsData(listData?.data)
    }
  }, [listData])

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      ApplySearch();
    }
  };

  const addNew = () => {
    navigate('/add-payment-terms', {
      state: {
        canAdd: menuRights?.canAdd,
        canEdit: menuRights?.canEdit
      }
    })
  }

  const handleClose = () => setShowModal(false);

  const handleView = (item) => { menuRights?.canView && setShowModal(item) }

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked
    if (activeData == false) {
      setSelected(oldData => [...oldData, e.target.value])
    } else {
      setSelected(selected.filter(values => values !== e.target.value))
    }
  };

  return (
    <>
      <section id="paymentTermsList">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
              <div className="card quote-toolbar-card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                      <div>
                        <p>{tableData?.length} Results Found</p>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 p-0">
                      <SearchComponent
                        filteredResults={tableData}
                        search={search}
                        handleKeyDown={handleKeyPress}
                        setSearch={setSearch}
                        removeSearch={removeSearch}
                        ApplySearch={ApplySearch}
                        RefreshList={RefreshList}
                        baseColumns={baseColumns}
                        selected={selected}
                        handleChange={handleChange}
                        data={paymentTermsList}
                        addNew={addNew}
                        HideFilter="HideFilter"
                        menuRights={menuRights} />
                    </div>
                  </div>
                  {/* <!-- search-area-sec ends --> */}
                </div>
              </div>
            </div>
          </div>
          <PaymentTermsGrid
            filteredResults={tableData}
            filterColumn={filterColumn}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            loading={loadingList}
            menuRights={menuRights}
            moduleName='paymentterms' />
        </div>
      </section>

      <DeleteModal deleteShow={deleteShow} handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />
      <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
      <SaveSuccessModel show={show} createMsg={createMsg} setShow={setShow} SuccessDoneClick={SuccessDoneClick} />

      {/* payment-terms-view-modal start */}
      <Modal show={showModal} onHide={handleClose} animation={false} centered className='payment-terms-view-modal' size="xl">
        <Modal.Header>
          <h5 className="modal-title">{showModal?.paymentDescription}</h5>
          <i className="fas fa-times" onClick={handleClose}></i>
        </Modal.Header>
        <Modal.Body>
          <div className='row mt-3'>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Payment Terms</h5>
                <h6>{showModal?.paymentDescription}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Credit Days</h5>
                <h6>{showModal?.creditDays}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Description (Tool Tips)</h5>
                <h6>{showModal?.paymentTooltip}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div className="ml-5">
                <h5>Status</h5>
                <h6>{showModal?.isActive ? 'Active' : 'InActive'}</h6>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Back
          </Button>
        </Modal.Footer>
      </Modal>
      {/* payment-terms-view-modal end */}
    </>
  );
};

export default PaymentTermsList;